import { selectIn } from 'common/util/selector'

const base = (state, props) => state.main.settings.roles

export const selectedRoleType = selectIn(base, 'selected_role_type')
export const summary = selectIn(base, 'summary')
export const globalRoleNames = selectIn(base, 'default_roles')
